import axios from 'axios'
import { Toast } from 'vant';
axios.defaults.timeout = 60 * 1000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'

let url = (process.env.NODE_ENV === 'development'
          ?
          'https://sys.baijiecloud.com' //http://27.128.156.246:8815
          :
          'https://sys.baijiecloud.com'
)

export function getHistory (params) {
    // https://sys.baijiecloud.com/api/getHistoryList?AccessionNumber=NHpNL0NPQlJkN01ZT2czMElWTldMd0Z5bEFwb1dzU1ZHV1RMUDdCeGtGQT0&house_id=dyzx_zong&a=123
    return new Promise ((resolve, reject) => {
        axios.get(url + '/api/getHistoryList', {params}).then(res => {
            resolve(res.data.data)
        }).catch(err => {
            reject(err)
            console.log(err)
            // let code=err.response.data.data.code
            // if(code=== 10001 ) Toast('分享过期')

        })
    })
}

export function getInformation (params) {
    params.page = 'index'
    return new Promise ((resolve, reject) => {
        axios.get(url + '/api/getInformation', {params}).then(res => {
            resolve(res.data)
        }).catch(err => {
            // console.log(err)
            // let code = err.response.data.data.code
            // if(code=== 10001 ) {
            //     Toast('分享过期')
            // }
            reject(err)
        })
    })
}

export function dicomRecover (params) {
    return new Promise ((resolve, reject) => {
        axios.get(url + '/api/dicom_recover', {params}).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

export function getAccessKey (params) {
    params.page = 'index'
    return new Promise ((resolve, reject) => {
        axios.get(url + '/api/getAccessKey', {params}).then(res => {
            resolve(res.data)
            console.log(res)
        }).catch(err => {
            reject(err)
            console.log(err)
        })
    })
}